export default __webpack_public_path__ + "adbb1161b78483498b63930db4f8a916.svg";